module.exports = __webpack_public_path__ + "img/razer-giveaway.71077797.jpg";